import { useState } from 'react'

import { MANAGEMENT_QUERY_KEY_GET_COMPANIES, useManagementGetCompanies } from '@apps-common/apis/management/company'
import { CompanyModal } from '@apps-common/apps/portal/pages/management/components/company'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { queryClient } from '@apps-common/lib'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  searchVal: string
}

export const CompanyTableView: React.FC<IProps> = ({ searchVal }) => {
  const [skip, setSkip] = useState<number>(0)
  const [take, setTake] = useState<number>(10)
  const { isLoading, isError, data } = useManagementGetCompanies({
    name: searchVal
  })

  const keys = [
    {
      title: 'Company',
      key: 'companyName',
      thClasses: '',
      tdClasses: ''
    },
    {
      title: 'Company Type',
      key: 'companyTypeName',
      thClasses: '',
      tdClasses: '',
      Component: (props: any) => <span className='capitalize'>{props.companyTypeName}</span>
    },
    {
      title: 'Default MC',
      key: 'defaultMonitoringCentreName',
      thClasses: '',
      tdClasses: ''
    },
    {
      title: 'Actions',
      key: 'actions',
      static: true,
      thClasses: 'text-right',
      tdClasses: '',
      Component: (props: any) => (
        <div className='flex items-center justify-end gap-[5px]'>
          <ModalButton
            component={CompanyModal}
            componentProps={{
              companyId: props.companyId,
              companies: props.companies
            }}
            confirmCallback={() => {
              queryClient.refetchQueries({ queryKey: MANAGEMENT_QUERY_KEY_GET_COMPANIES(searchVal) })
            }}
            enterAnimation={modalSlideUpEnterAnimation}
            leaveAnimation={modalSlideUpLeaveAnimation}
          >
            <ButtonRoundSm type='div' className='action-brand-solid'>
              <commonIcons.arrowAngled />
            </ButtonRoundSm>
          </ModalButton>
        </div>
      )
    }
  ]

  const loading = isLoading || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[65px] sm:pt-[25px]'>
        <Table
          loading={loading}
          loadingSkeletonHeight='leading-[30px]'
          placeholderSkeletonHeight='leading-[30px]'
          pagination={{
            loading,
            count: data?.length || 0,
            skip,
            take,
            onSkipChanged: (value: number) => setSkip(value),
            onTakeChanged: (value: number) => setTake(value)
          }}
          keys={keys}
          data={data?.map((c) => ({ ...c, companies: data })) || []}
          sliceData
          topLeftComponent={
            <>
              {!loading && data && (
                <div className='jost-light'>
                  <span className='jost-medium'>{data?.length}</span> company results
                </div>
              )}
              {(loading || !data) && <div className='h-[22px] w-[100px] bg-skeleton rounded-lg' />}
            </>
          }
          onSkipChanged={(value: number) => setSkip(value)}
          onTakeChanged={(value: number) => setTake(value)}
        />
      </LayoutPadding>
    </LayoutContainer>
  )
}
